import React from 'react';
import ButtonPrimary from '../Form/ButtonPrimary';
import FooterLinks from './FooterLinks';
import { useLoginContext } from '../../Contexts/LoginContext';
import ButtonOpenStoreCounter from './ButtonOpenStoreCounter';
import { TbArrowBigRightFilled, TbChecklist, TbHash, TbSend } from 'react-icons/tb';
import { useCartContext } from '../../Contexts/CartContext';
import { useStoreContext } from '../../Contexts/StoreContext';
import { formatCartId } from '../../Utils/Formatters';
import { useCheckoutContext } from '../../Contexts/CheckoutContext';
import { useLocation } from 'react-router-dom';
import { useStoreHook } from '../../Hooks/StoreHook';

const FooterStoreCounter = () => {

    const { user } = useLoginContext();
    const { cartConference, cartDisplay, cartFinished, getTotalQuantityProductsInConference, setShowCart, setShowCartConference } = useCartContext();
    const { currentStore, cashier } = useStoreContext();
    const { order } = useCheckoutContext();
    const location = useLocation();
    const { getLinkToHome } = useStoreHook();
    const isHome = location.pathname === getLinkToHome();

    return (
        <section className='flex flex-col w-full'>

            {(currentStore && !order) &&
                <>
                    <FooterLinks />
                    {(isHome && (cashier || cartFinished)) &&
                        <section className={`${(!user || !cartDisplay) && 'block md:hidden'} fixed z-30 flex gap-3 items-center justify-between w-full bottom-0 p-4 bg-white text-sm ring-t-1 ring-white/50 rounded-t-xl shadow-reverse-md`}>
                            {(!user || !cartDisplay)
                                ?
                                    <div className='w-full'>
                                        <ButtonOpenStoreCounter />
                                    </div>
                                :
                                    <div className='flex gap-3 w-full'>
                                        {cartConference.length === 0 &&
                                            <ButtonPrimary outline onClick={() => setShowCart(true)} disabled={!cartDisplay} className={`text-sm flex items-center font-semibold gap-0.5 md:max-w-md ${cartConference.length === 0 && 'w-full'}`}>
                                                <div className='flex gap-4 w-full items-center justify-between'>
                                                    <div className='flex items-center text-xl font-black leading-5'>
                                                        <span><TbHash /></span>
                                                        <span>{ formatCartId(cartDisplay?.id) }</span>
                                                    </div>
                                                    {cartConference.length === 0 &&
                                                        <div className="flex flex-col text-right pr-1 font-bold leading-4">
                                                            Confira ou feche sua comanda
                                                        </div>
                                                    }
                                                </div>
                                            </ButtonPrimary>
                                        }

                                        {cartConference.length > 0 &&
                                            <div className='flex items-center w-full gap-1'>
                                                <div className='flex justify-end w-12'><TbArrowBigRightFilled size={30} className='animate-side text-custom-primary' /></div>
                                                <ButtonPrimary outline onClick={() => setShowCartConference(true)} disabled={cartConference.length === 0}
                                                    className={`relative text-nowrap w-full md:max-w-72 gap-2 items-center ${cartConference.length > 0 ? 'justify-between' : 'justify-center bg-gray-100 ring-gray-100 text-gray-500'}`}>
                                                    <span className='flex gap-0.5 items-center'>
                                                        {cartConference.length > 0 
                                                            ?   <div className='flex items-center gap-0.5'>
                                                                    <TbChecklist size={20} /> <span>Confira e envie seu pedido</span>
                                                                    <div className='absolute top-0 right-0 text-shopfood-notify rounded-full bg-white'>
                                                                        <TbSend size={20} className='animate-pulse' />
                                                                    </div>
                                                                </div> 
                                                            : 'Adicione produtos'} </span>
                                                    {cartConference.length > 0 && <span>{getTotalQuantityProductsInConference(cartConference) > 1 ? `${getTotalQuantityProductsInConference(cartConference)} itens` : `${getTotalQuantityProductsInConference(cartConference)} item`}</span>}
                                                </ButtonPrimary>
                                            </div>
                                        }
                                    </div>
                            }
                        </section>
                    }
                </>
            }
        </section>
    )
}

export default FooterStoreCounter;
